import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-search',
  templateUrl: './search.component.html',
})

export class SearchComponent {
  @Input() placeHolder: string;
  @Input() isEnterClicked: boolean;
  @Input() isDisabled: boolean;
  searchTimeout: any;

  @Output() readonly search: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('input', {static: true}) input: ElementRef;

  onSearch(term: string, event: KeyboardEvent): void {
    if (this.isEnterClicked) {
      if (event.key === 'Enter') {
        this.search.emit(term);
      }
    } else {
      if (term.length > 2 || term === '') {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.search.emit(term);
        }, 1000);
      }
    }
  }

  onResetSearch(term: string): void {
    this.input.nativeElement.value = '';
    this.search.emit(term);
  }
}
